var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-box-picture"},[_c('b-loading',{attrs:{"is-full-page":false,"active":_vm.isLoading,"can-cancel":false},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('div',{staticClass:"grid-box-picturebox",class:{'active': _vm.isLoaded},style:({ 'background-image':'url('+_vm.image+')'})})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }